import {useQuery} from "@apollo/client";
import {useContext, useState} from "react";

import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {EmptyTable} from "@/components/table/subComponents/EmptyTable/EmptyTable.tsx";
import {Sorting, SortingDirection} from "@/components/table/Table.types";
import {useTable} from "@/lib/hooks/useTable.ts";
import {ExternalUsersPageResult, GQL_EXTERNAL_USERS} from "@/lib/queries/statuspagesExternalUsers.ts";
import {StatusPageContext} from "@/pages/statuspages/statuspages-manage/ManageStatusPageTabContainer.utils.tsx";
import {AddExternalUserAction} from "@/pages/statuspages/tabs/external-users/actions/AddExternalUserAction.tsx";
import {EmptyExternalUsers} from "@/pages/statuspages/tabs/external-users/components/EmptyExternalUsers.tsx";
import {StatusPageExternalUsersTable} from "@/pages/statuspages/tabs/external-users/StatusPageExternalUsersTable.tsx";

export const StatusPageExternalUsersTab = () => {
  const {statusPage} = useContext(StatusPageContext);
  const {search, searchDebounced, searchChanged, pagination, setPagination} = useTable();
  const [sorting, setSorting] = useState<Sorting>({column: "external_user__email", direction: SortingDirection.Asc});
  const {data, previousData} = useQuery<ExternalUsersPageResult>(GQL_EXTERNAL_USERS, {
    variables: {
      statusPageID: statusPage.id,
      ...pagination,
      sort: sorting.direction == SortingDirection.Asc ? sorting.column : `-${sorting.column}`,
      search: searchDebounced,
    },
  });
  const currentData = data?.externalUsers || previousData?.externalUsers;
  const items = currentData?.items || [];
  const total = currentData?.total || 0;

  return (
    <div className={"d-flex flex-column gap-3"}>
      <ActionBarWrapper
        left={<SearchInput value={search} onChange={(v) => searchChanged(v)} variant={"tableControlBar"} />}
        right={<AddExternalUserAction statusPageID={statusPage.id} />}
      />
      <StatusPageExternalUsersTable
        statusPageID={statusPage.id}
        items={items}
        sortColumn={sorting.column}
        sortDirection={sorting.direction}
        onSortingChange={(newSorting) => {
          setSorting(newSorting);
        }}
        noDataComponent={
          currentData && (
            <EmptyTable colSpan={4}>
              <EmptyExternalUsers variant={search.length > 0 ? "filter" : "general"} />
            </EmptyTable>
          )
        }
        pagination={pagination}
        totalRows={total}
        updatePagination={setPagination}
        paginationData={items}
      />
    </div>
  );
};
